<ada-card
	#InstallTimePropertiesCard
	id="InstallTimePropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Install Time Properties"
		data-container-selector="ada-card-header"
		id="InstallTimePropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<ng-container *ngIf="'ObjectID' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				#ObjectIdLabel
				id="ObjectIdLabel"
				[content]="'Object ID'"
				[inheriting]="(currentPropertyObject?.ObjectID | inheritPipe: inheritedPropertyObject?.ObjectID) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'ObjectID' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('ObjectID')"
			/>
			<ada-input
				#ObjectIDInput
				id="ObjectIDInput"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[type]="'number'"
				[value]="currentPropertyObject?.ObjectID"
				(valueChange)="setObjectPropertyValue('ObjectID', +$event)"
			/>
		</ng-container>
		<ng-container *ngIf="'UnpackingFolder' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				#UnpackingFolderLabel
				id="UnpackingFolderLabel"
				[content]="'Unpacking Folder'"
				[inheriting]="
					(currentPropertyObject?.UnpackingFolder | inheritPipe: inheritedPropertyObject?.UnpackingFolder) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'UnpackingFolder' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('UnpackingFolder')"
			/>
			<ada-input
				#UnpackingFolderInput
				id="UnpackingFolderInput"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[placeholder]="'Unpacking Folder'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[type]="'text'"
				[value]="currentPropertyObject?.UnpackingFolder"
				(valueChange)="setObjectPropertyValue('UnpackingFolder', $event)"
			/>
		</ng-container>
		<ng-container *ngIf="'AutoITScriptPath' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				#AutoITScriptPathLabel
				id="AutoITScriptPathLabel"
				[content]="'Auto IT Script Path'"
				[inheriting]="
					(currentPropertyObject?.AutoITScriptPath | inheritPipe: inheritedPropertyObject?.AutoITScriptPath) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'AutoITScriptPath' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('AutoITScriptPath')"
			/>
			<ada-input
				#AutoITScriptPathInput
				id="AutoITScriptPathInput"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[placeholder]="'Auto IT Script Path'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[type]="'text'"
				[value]="currentPropertyObject?.AutoITScriptPath"
				(valueChange)="setObjectPropertyValue('AutoITScriptPath', $event)"
			/>
		</ng-container>
		<ng-container *ngIf="'SuppressReboots' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				#SuppressRebootsLabel
				id="SuppressRebootsLabel"
				[content]="'Suppress Reboots'"
				[inheriting]="
					(currentPropertyObject?.SuppressReboots | inheritPipe: inheritedPropertyObject?.SuppressReboots) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'SuppressReboots' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('SuppressReboots')"
			/>
			<ada-toggle-switch
				#SuppressRebootsInput
				id="SuppressRebootsInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.SuppressReboots"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('SuppressReboots', $event)"
			/>
		</ng-container>
		@if ('InterferingProcessHandlers' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization) {
			@let _hasNoProcesses = interferingProcessKeyOptions().length === 0;
			<ada-authoring-property-label
				#InterferingProcessHandlersLabel
				content="Interfering Process Handlers"
				id="InterferingProcessHandlersLabel"
				[inheriting]="
					(currentPropertyObject?.InterferingProcessHandlers | inheritPipe: inheritedPropertyObject?.InterferingProcessHandlers) ||
					isInheritanceDisabled
				"
				[isDisabled]="isDisabled || _hasNoProcesses"
				[isRequired]="'InterferingProcessHandlers' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('InterferingProcessHandlers')"
			/>
			<ada-key-value-builder
				#InterferingProcessHandlersInput
				id="InterferingProcessHandlers"
				keyPlaceholder="Interfering Process"
				keyType="option"
				valueType="option"
				[entries]="currentPropertyObject?.InterferingProcessHandlers"
				[isDisabled]="isDisabled || _hasNoProcesses"
				[keyResponsiveConfig]="interferingProcessResponsiveConfig"
				[optionKeys]="interferingProcessKeyOptions()"
				[optionValues]="interferingProcessOptions"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[validators]="keyValidators"
				[valueResponsiveConfig]="interferingProcessResponsiveConfig"
				(entriesChange)="setObjectPropertyValue('InterferingProcessHandlers', $event)"
			/>
		}
	</ada-container>
</ada-card>
